import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableContainer,
    TableRow,
    Paper,
    TableCell,
    TableHead
} from '@material-ui/core';
import { useApi } from '../../components/api';


export const InvitesTable = () => {

    const { api } = useApi();
    const [rows, setRows] = useState<any[]>([]);

    useEffect(() => {

        const load = async () => {
            const resp = await api.get<{ data: any[]; }>('tenant/invites?role=Client');

            setRows(resp.data.data);
        };

        load();

    }, [api]);

    return <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell align="left">Id</TableCell>
                    <TableCell align="right">Criado Em</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="right">Codigo no Sistema</TableCell>
                    <TableCell align="right">Aceito Em:</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.name}>
                        <TableCell align="left">{row.id}</TableCell>
                        <TableCell align="right">{new Date(row.createdAt).toLocaleDateString()}</TableCell>
                        <TableCell align="left">{row.targetEmail}</TableCell>
                        <TableCell align="right">{row.targetRefCode}</TableCell>
                        <TableCell align="right">{row.acceptedAt ? new Date(row.acceptedAt).toLocaleDateString() : "Pendente"}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>;
};
